export const clearDixaBrowserState = () => {
  try {
    // eslint-disable-next-line no-underscore-dangle
    if (window._dixa_ && typeof window._dixa_.invoke === 'function') {
      // eslint-disable-next-line no-underscore-dangle
      window._dixa_.invoke('shutdown');
    }
  } catch (e) {
    /* empty */
  }

  [window.localStorage, window.sessionStorage].forEach(storage => {
    if (!storage) return;
    try {
      const keysToRemove = [];
      for (let i = 0; i < storage.length; i += 1) {
        const key = storage.key(i);
        if (key && key.toLowerCase().indexOf('dixa') !== -1) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(k => storage.removeItem(k));
    } catch (e) {
      /* empty */
    }
  });

  try {
    document.cookie.split(';').forEach(entry => {
      const name = entry.split('=')[0].trim();
      if (name && name.toLowerCase().indexOf('dixa') !== -1) {
        document.cookie = `${name}=; Max-Age=0; path=/`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
      }
    });
  } catch (e) {
    /* empty */
  }
};
